module.exports = __webpack_public_path__ + "static/media/btn_nose_active.cd5fc07d.png";